// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import {
//   Card,
//   CardContent,
//   Typography,
//   Grid,
//   Box,
//   useTheme,
//   useMediaQuery,
//   Avatar,
//   Skeleton,
//   LinearProgress,
// } from '@mui/material';
// import {
//   Store as SellersIcon,
//   People as UsersIcon,
//   Category as CategoryIcon,
//   ShoppingBag as ProductsIcon,
//   PendingActions as PendingOrdersIcon,
//   HourglassEmpty as ProcessingOrdersIcon,
//   LocalShipping as ShippingOrdersIcon,
//   CheckCircle as DeliveredOrdersIcon,
// } from '@mui/icons-material';
// import { getWithTokenAPI } from "../utils/Api";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { useSelector } from "react-redux"
 
// // Recharts imports for charts
// import {
//   PieChart,
//   Pie,
//   Cell,
//   Tooltip,
//   ResponsiveContainer,
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   Legend,
//   CartesianGrid,
// } from 'recharts';
 
// const primaryGreen = "#DC3545";
// const lightGreyBlue = '#F0F4F8'; 
// const darkGreyText = '#2D3748'; 
// const mediumGreyText = '#718096'; 
// const cardWhite = '#FFFFFF'; 
// const accentGreen = '#4CAF50'; 
// const accentOrange = '#FF9800'; 
// const accentBlue = '#2196F3'; 
// const accentAmber = '#FFC107'; 
 
// const CHART_COLORS = [
//   accentGreen,   
//   accentOrange,
//   accentBlue,    
//   accentAmber,   
// ];
 
// const CustomTooltip = ({ active, payload, label }) => {
//   if (active && payload && payload.length) {
//     return (
//       <Box sx={{
//         bgcolor: cardWhite,
//         p: 1.5,
//         border: '1px solid #e0e0e0',
//         borderRadius: 2,
//         boxShadow: '0px 2px 10px rgba(0,0,0,0.1)',
//       }}>
//         <Typography variant="body2" sx={{ color: darkGreyText, fontWeight: 600 }}>
//           {payload[0].name}: {payload[0].value} Orders
//         </Typography>
//       </Box>
//     );
//   }
//   return null;
// };
 
// const TodayOrdersDonutChart = ({ data, loading }) => {
//   if (loading) {
//     return (
//       <Card sx={{ borderRadius: 3, boxShadow: '0 8px 25px rgba(0,0,0,0.1)', height: 350, bgcolor: cardWhite }}>
//         <CardContent>
//           <Typography variant="h6" sx={{ fontWeight: 600, color: darkGreyText, mb: 2 }}>
//             Today's Order Summary
//           </Typography>
//           <Skeleton variant="circular" width={150} height={150} sx={{ margin: 'auto', bgcolor: lightGreyBlue }} />
//           <Skeleton variant="text" sx={{ mt: 3, bgcolor: lightGreyBlue }} />
//           <Skeleton variant="text" width="80%" sx={{ bgcolor: lightGreyBlue }} />
//         </CardContent>
//       </Card>
//     );
//   }
 
//   const chartData = [
//     { name: 'Delivered', value: data?.delivered || 0 },
//     { name: 'Pending', value: data?.pending || 0 },
//     { name: 'Processing', value: data?.processing || 0 },
//     { name: 'Shipped', value: data?.shipped || 0 },
//   ].filter(item => item.value > 0);
 
//   const totalOrdersToday = chartData.reduce((sum, item) => sum + item.value, 0);
 
//   return (
//     <Card sx={{ borderRadius: 3, boxShadow: '0 8px 25px rgba(0,0,0,0.1)', height: '100%', minHeight: 350, bgcolor: cardWhite }}>
//       <CardContent sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
//         <Typography variant="h6" sx={{ fontWeight: 600, color: darkGreyText, mb: 2 }}>
//           Today's Order Summary
//         </Typography>
//         <Box sx={{ flexGrow: 1, position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
//           <ResponsiveContainer width="100%" height="100%">
//             <PieChart>
//               <Pie
//                 data={chartData}
//                 cx="50%"
//                 cy="50%"
//                 innerRadius={70}
//                 outerRadius={100}
//                 fill="#8884d8"
//                 paddingAngle={3}
//                 dataKey="value"
//                 cornerRadius={5}
//                 stroke={cardWhite}
//                 strokeWidth={2}
//               >
//                 {chartData.map((entry, index) => (
//                   <Cell key={`cell-${index}`} fill={CHART_COLORS[index % CHART_COLORS.length]} />
//                 ))}
//               </Pie>
//               <Tooltip content={<CustomTooltip />} />
//               <Legend
//                 layout="horizontal"
//                 verticalAlign="bottom"
//                 align="center"
//                 wrapperStyle={{ paddingTop: 20 }}
//               />
//             </PieChart>
//           </ResponsiveContainer>
//           <Box sx={{
//             position: 'absolute',
//             top: '50%',
//             left: '50%',
//             transform: 'translate(-50%, -50%)',
//             textAlign: 'center',
//             pointerEvents: 'none'
//           }}>
//             <Typography variant="h5" sx={{ fontWeight: 700, color: darkGreyText }}>
//               {totalOrdersToday}
//             </Typography>
//             <Typography variant="caption" sx={{ color: mediumGreyText }}>
//               Total Orders
//             </Typography>
//           </Box>
//         </Box>
//       </CardContent>
//     </Card>
//   );
// };
 
 
// // Monthly Orders Bar Chart Component
// const MonthlyOrdersChart = ({ data, loading }) => {
//   if (loading) {
//     return (
//       <Card sx={{ borderRadius: 3, boxShadow: '0 8px 25px rgba(0,0,0,0.1)', height: 350, bgcolor: cardWhite }}>
//         <CardContent>
//           <Typography variant="h6" sx={{ fontWeight: 600, color: darkGreyText, mb: 2 }}>
//             Last 30 Days Order Trends
//           </Typography>
//           <Skeleton variant="rectangular" width="100%" height={200} sx={{ bgcolor: lightGreyBlue }} />
//           <Skeleton variant="text" sx={{ mt: 3, bgcolor: lightGreyBlue }} />
//         </CardContent>
//       </Card>
//     );
//   }
 
//   const chartData = Array.isArray(data) ? data : [];
 
//   const formattedData = chartData.map(item => ({
//     date: item.date || '',
//     delivered: item.delivered || 0,
//     shipped: item.shipped || 0,
//     pending: item.pending || 0,
//     processing: item.processing || 0,
//   }));
 
//   return (
//     <Card sx={{ borderRadius: 3, boxShadow: '0 8px 25px rgba(0,0,0,0.1)', height: '100%', minHeight: 350, bgcolor: cardWhite }}>
//       <CardContent sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
//         <Typography variant="h6" sx={{ fontWeight: 600, color: darkGreyText, mb: 2 }}>
//           Last 30 Days Order Trends
//         </Typography>
//         <Box sx={{ flexGrow: 1 }}>
//           <ResponsiveContainer width="100%" height={300}>
//             <BarChart
//               data={formattedData}
//               margin={{
//                 top: 20,
//                 right: 30,
//                 left: 20,
//                 bottom: 5, // Increased bottom margin for rotated labels
//               }}
//             >
//               <CartesianGrid strokeDasharray="3 3" vertical={false} stroke={lightGreyBlue} />
//               <XAxis
//                 dataKey="date"
//                 stroke={mediumGreyText}
//                 tickFormatter={(tick) => {
//                   const date = new Date(tick);
//                   return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
//                 }}
//                 interval={0} // Force display all ticks
//                 angle={-45}  // Rotate labels by -45 degrees
//                 textAnchor="end" // Anchor text to the end for better alignment with rotation
//                 height={60} // Give more height to XAxis to prevent labels from being cut off
//               />
//               <YAxis stroke={mediumGreyText} />
//               <Tooltip />
//               <Legend />
//               <Bar
//                 dataKey="delivered"
//                 stackId="a"
//                 fill={accentGreen} // Green
//                 name="Delivered"
//               />
//               <Bar
//                 dataKey="shipped"
//                 stackId="a"
//                 fill={accentAmber}
//                 name="Shipped"
//               />
//               <Bar
//                 dataKey="pending"
//                 stackId="a"
//                 fill={accentOrange}
//                 name="Pending"
//               />
//               <Bar
//                 dataKey="processing"
//                 stackId="a"
//                 fill={accentBlue} 
//                 name="Processing"
//               />
//             </BarChart>
//           </ResponsiveContainer>
//         </Box>
//       </CardContent>
//     </Card>
//   );
// };
 
// const DashboardPage = () => {
//   const [dashboardData, setDashboardData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const navigate = useNavigate();
//   const theme = useTheme();
//   const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
//   const token = localStorage.getItem("token");
//   const [ordercount , setordercount] = useState(null)
 
//   const fetchDashboardData = async () => {
//     if (!token) {
//       setLoading(false);
//       console.warn("Access token not found in localStorage. Redirecting to login or showing error.");
//       return;
//     }
 
//     try {
//       setLoading(true);
//       const response = await getWithTokenAPI(token, "/admin/admin-dashboard");
 
//       if (response.statusCode === 200 && response.data) {
//         const mockMonthlyData = [];
//         for (let i = 29; i >= 0; i--) {
//           const date = new Date();
//           date.setDate(date.getDate() - i);
//           const formattedDate = date.toISOString().slice(0, 10); //YYYY-MM-DD
//           mockMonthlyData.push({
//             date: formattedDate,
//             delivered: Math.floor(Math.random() * 10) + 1,
//             shipped: Math.floor(Math.random() * 5) + 1,
//             pending: Math.floor(Math.random() * 3) + 1,
//             processing: Math.floor(Math.random() * 2) + 1,
//           });
//         }
 
//         setDashboardData({
//           totalSellers: response.data.totalSellers || 0,
//           totalUsers: response.data.totalUsers || 0,
//           totalCategories: response.data.totalCategories || 0,
//           totalProducts: response.data.totalProducts || 0,
//           orders: {
//             pending: response.data.orders?.pending || 0,
//             processing: response.data.orders?.processing || 0,
//             shipping: response.data.orders?.shipping || 0,
//             delivered: response.data.orders?.delivered || 0,
//           },
//           todayOrders: response.data.todayOrders,
//           monthlyOrdersSummary: mockMonthlyData,
//         });
//       } else {
//         toast.error("Failed to fetch dashboard data.");
//         console.error("Error fetching dashboard data:", response.message);
//       }
//     } catch (error) {
//       toast.error("An error occurred while fetching dashboard data.");
//       console.error("API Error:", error);
//     } finally {
//       setLoading(false);
//     }
//   };
 
//   useEffect(() => {
//     fetchDashboardData();
//   }, [token]);

// // useEffect(() => {
// //   const fetchOrderData = async () => {
// //     const token = localStorage.getItem("token");
// //     if (!token) return;

// //     try {
// //       const res = await getWithTokenAPI(token, "/order/find-all");
// //       if (res.statusCode === 200) {
// //         const orders = res.data.orders || [];

// //         // Count orders by status
// //         const pendingCount = orders.filter(order => order.order_status === "Pending").length;
// //         const processingCount = orders.filter(order => order.order_status === "Processing").length;
// //         const shippedCount = orders.filter(order => order.order_status === "Shipped").length;
// //         const deliveredCount = orders.filter(order => order.order_status === "Delivered").length;
// //         setordercount({pendingCount,processingCount,shippedCount,deliveredCount})

// //       } else {
// //         toast.error(res.message || "Failed to load orders.");
// //       }
// //     } catch (error) {
// //       console.error("Fetch orders error:", error);
// //       toast.error("Failed to load orders due to a network error.");
// //     }
// //   };

// //   fetchOrderData();
// // }, [token]);

 
// useEffect(() => {
//   const fetchOrderData = async () => {
//     const token = localStorage.getItem("token");
//     if (!token) return;

//     try {
//       const res = await getWithTokenAPI(token, "/order/find-all");
//       if (res.statusCode === 200) {
//         const orders = res.data.orders || [];

//         // Filter out orders where cart is empty or seller name is empty/not available
//         const validOrders = orders.filter(order => {
//           // Check if cart exists and has items
//           if (!order.cart_id?.cart || order.cart_id.cart.length === 0) {
//             return false;
//           }
          
//           // Check if at least one item has a valid seller name
//           return order.cart_id.cart.some(item => 
//             item.seller_id?.name && item.seller_id.name.trim() !== ""
//           );
//         });

//         // Count orders by status after filtering
//         const pendingCount = validOrders.filter(order => order.order_status === "Pending").length;
//         const processingCount = validOrders.filter(order => order.order_status === "Processing").length;
//         const shippedCount = validOrders.filter(order => order.order_status === "Shipped").length;
//         const deliveredCount = validOrders.filter(order => order.order_status === "Delivered").length;
        
//         setordercount({pendingCount, processingCount, shippedCount, deliveredCount});

//       } else {
//         toast.error(res.message || "Failed to load orders.");
//       }
//     } catch (error) {
//       console.error("Fetch orders error:", error);
//       toast.error("Failed to load orders due to a network error.");
//     }
//   };

//   fetchOrderData();
// }, [token]);
 
 
//   const handleCardClick = (route) => {
//     if (route) {
//       navigate(`/backoffice/${route}`);
//     }
//   };
 
//   const topCards = [
//     {
//       title: "Total Sellers",
//       value: dashboardData?.totalSellers,
//       icon: <SellersIcon fontSize="large" />,
//       route: "sellermanagement"
//     },
//     {
//       title: "Total Users",
//       value: dashboardData?.totalUsers,
//       icon: <UsersIcon fontSize="large" />,
//       route: "usermanagement"
//     },
//     {
//       title: "Total Categories",
//       value: dashboardData?.totalCategories,
//       icon: <CategoryIcon fontSize="large" />,
//       route: "category"
//     },
//     {
//       title: "Total Products",
//       value: dashboardData?.totalProducts,
//       icon: <ProductsIcon fontSize="large" />,
//       route: "productmanagement"
//     },
//   ];
 
//   const orderCards = [
//     {
//       title: "Pending Orders",
//       value:ordercount?.pendingCount,
//       icon: <PendingOrdersIcon fontSize="large" />,
//       route: "order"
//     },
//     {
//       title: "Processing Orders",
//       value: ordercount?.processingCount,
//       icon: <ProcessingOrdersIcon fontSize="large" />,
//       route: "order"
//     },
//     {
//       title: "Shipping Orders",
//       value: ordercount?.shippedCount,
//       icon: <ShippingOrdersIcon fontSize="large" />,
//       route: "order"
//     },
//     {
//       title: "Delivered Orders",
//       value: ordercount?.deliveredCount,
//       icon: <DeliveredOrdersIcon fontSize="large" />,
//       route: "order"
//     },
//   ];
 
//   const CardComponent = ({ title, value, icon, route, loadingState }) => (
//     <Card
//       onClick={() => handleCardClick(route)}
//       sx={{
//         borderRadius: 3,
//         // boxShadow: '0 8px 25px rgba(0,0,0,0.1)',
//         transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
//         '&:hover': {
//           transform: 'translateY(-10px)',
//           boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
//           cursor: 'pointer',
//         },
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'space-between',
//         height: 140,
//         width: 230,
//         backgroundColor: cardWhite, // Use white for card background
//         color: darkGreyText, // Default text color
//         position: 'relative',
//         overflow: 'hidden',
//       }}
//     >
//       <CardContent sx={{ flexGrow: 1, p: 3 }}>
//         <Box sx={{
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center',
//           mb: 1.5,
//         }}>
//           <Typography variant="subtitle1" sx={{ fontWeight: 600, color: darkGreyText }}>
//             {title}
//           </Typography>
//           <Avatar sx={{
//             bgcolor: lightGreyBlue, // Light grey-blue for avatar background
//             color: primaryGreen, // Primary green for icon color (highlight)
//             width: 50,
//             height: 50,
//           }}>
//             {icon}
//           </Avatar>
//         </Box>
//         {loadingState ? (
//           <Skeleton variant="text" width="70%" height={isSmallScreen ? 45 : 55} sx={{ bgcolor: lightGreyBlue }} />
//         ) : (
//           <Typography
//             variant={isSmallScreen ? "h5" : "h4"}
//             sx={{ fontWeight: 600, color:darkGreyText, mb: 4 }} // Primary green for value (highlight)
//           >
//             {value !== undefined && value !== null ? value : 'N/A'}
//           </Typography>
//         )}
//       </CardContent>
//       <Box sx={{
//         height:4,
//         backgroundColor: primaryGreen, // Primary green for the bottom bar (highlight)
//         width: '100%',
//         position: 'absolute',
//         bottom: 0,
//         left: 0,
//         borderBottomLeftRadius: 12,
//         borderBottomRightRadius: 12,
//       }} />
//     </Card>
//   );
 
//   return (
//     <Box
//       sx={{
//         p: isSmallScreen ? 2 : 4,
     
//         minHeight: '100vh',
//         width: '100%',
//         boxSizing: 'border-box',
//       }}
//     >
//       <ToastContainer position="top-center" autoClose={2000} />
 
//       {/* Top Row Cards */}
//       <Grid
//         container
//         spacing={isSmallScreen ? 2 : 2}
//         sx={{ mb: isSmallScreen ? 4 : 6, justifyContent: "space-evenly" }}
//       >
//         {topCards.map((card, index) => (
//           <Grid
//             item
//             xs={12}
//             sm={6}
//             md={4}
//             lg={2}
//             key={index}
//           >
//             <CardComponent
//               title={card.title}
//               value={card.value}
//               icon={card.icon}
//               route={card.route}
//               loadingState={loading}
//             />
//           </Grid>
//         ))}
//       </Grid>
 
//       {/* Orders Section */}
//       <Typography variant="h5" sx={{ mb: isSmallScreen ? 3 : 4, fontWeight: 700, color: darkGreyText, pl: 2 }}>
//         Order Statistics
//       </Typography>
 
//       <Grid
//         container
//         spacing={isSmallScreen ? 2 : 2}
//         sx={{ mb: isSmallScreen ? 4 : 6, justifyContent: "space-evenly" }}
//       >
//         {orderCards.map((card, index) => (
//           <Grid
//             item
//             xs={12}
//             sm={6}
//             md={4}
//             lg={3}
//             key={index}
//             sx={{
//               display: 'flex',
//               justifyContent: 'center',
//             }}
//           >
//             <CardComponent
//               title={card.title}
//               value={card.value}
//               icon={card.icon}
//               route={card.route}
//               loadingState={loading}
//             />
//           </Grid>
//         ))}
//       </Grid>
 
//       {/* Detailed Order Insights Section (Charts) */}
//       <Typography variant="h5" sx={{ mb: isSmallScreen ? 3 : 4, fontWeight: 700, color: darkGreyText, pl: 2 }}>
//         Detailed Order Insights
//       </Typography>
 
//       <Grid container spacing={isSmallScreen ? 2 : 4} style={{ width: "100%" }}>
//         {/* Today's Orders Donut Chart */}
//         <Grid item xs={12} md={6} style={{ width: "100%" }}>
//           <TodayOrdersDonutChart
//             data={dashboardData?.todayOrders}
//             loading={loading}
//           />
//         </Grid>
 
//         {/* Monthly Orders Bar Chart */}
//         <Grid item xs={12} md={6} style={{ width: "100%" }}>
//           <MonthlyOrdersChart
//             data={dashboardData?.monthlyOrdersSummary}
//             loading={loading}
//           />
//         </Grid>
//       </Grid>
//     </Box>
//   );
// };
 
// export default DashboardPage;
 
 

"use client"

import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { Card, CardContent, Typography, Grid, Box, useTheme, useMediaQuery, Avatar, Skeleton } from "@mui/material"
import {
  Store as SellersIcon,
  People as UsersIcon,
  Category as CategoryIcon,
  ShoppingBag as ProductsIcon,
  PendingActions as PendingOrdersIcon,
  HourglassEmpty as ProcessingOrdersIcon,
  LocalShipping as ShippingOrdersIcon,
  CheckCircle as DeliveredOrdersIcon,
} from "@mui/icons-material"
import { getWithTokenAPI } from "../utils/Api"
import { toast, ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

// Recharts imports for charts
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Legend,
  CartesianGrid,
  LabelList,
  ReferenceLine,
} from "recharts"

const primaryGreen = "#DC3545"
const lightGreyBlue = "#F0F4F8"
const darkGreyText = "#2D3748"
const mediumGreyText = "#718096"
const cardWhite = "#FFFFFF"
const accentGreen = "#4CAF50"
const accentOrange = "#FF9800"
const accentBlue = "#2196F3"
const accentAmber = "#FFC107"

const CHART_COLORS = [accentGreen, accentOrange, accentBlue, accentAmber]

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <Box
        sx={{
          bgcolor: cardWhite,
          p: 1.5,
          border: "1px solid #e0e0e0",
          borderRadius: 2,
          boxShadow: "0px 2px 10px rgba(0,0,0,0.1)",
        }}
      >
        <Typography variant="body2" sx={{ color: darkGreyText, fontWeight: 600 }}>
          {payload[0].name}: {payload[0].value} Orders
        </Typography>
      </Box>
    )
  }
  return null
}

const TodayOrdersDonutChart = ({ data, loading }) => {
  if (loading) {
    return (
      <Card sx={{ borderRadius: 3, boxShadow: "0 8px 25px rgba(0,0,0,0.1)", height: 350, bgcolor: cardWhite }}>
        <CardContent>
          <Typography variant="h6" sx={{ fontWeight: 600, color: darkGreyText, mb: 2 }}>
            {"Today's Order Summary"}
          </Typography>
          <Skeleton variant="circular" width={150} height={150} sx={{ margin: "auto", bgcolor: lightGreyBlue }} />
          <Skeleton variant="text" sx={{ mt: 3, bgcolor: lightGreyBlue }} />
          <Skeleton variant="text" width="80%" sx={{ bgcolor: lightGreyBlue }} />
        </CardContent>
      </Card>
    )
  }

  const chartData = [
    { name: "Delivered", value: data?.delivered || 0 },
    { name: "Pending", value: data?.pending || 0 },
    { name: "Processing", value: data?.processing || 0 },
    { name: "Shipped", value: data?.shipped || 0 },
  ].filter((item) => item.value > 0)

  const totalOrdersToday = chartData.reduce((sum, item) => sum + item.value, 0)

  return (
    <Card
      sx={{
        borderRadius: 3,
        boxShadow: "0 8px 25px rgba(0,0,0,0.1)",
        height: "100%",
        minHeight: 350,
        bgcolor: cardWhite,
      }}
    >
      <CardContent sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Typography variant="h6" sx={{ fontWeight: 600, color: darkGreyText, mb: 2 }}>
          {"Today's Order Summary"}
        </Typography>
        <Box
          sx={{ flexGrow: 1, position: "relative", display: "flex", justifyContent: "center", alignItems: "center" }}
        >
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={chartData}
                cx="50%"
                cy="50%"
                innerRadius={70}
                outerRadius={100}
                fill="#8884d8"
                paddingAngle={3}
                dataKey="value"
                cornerRadius={5}
                stroke={cardWhite}
                strokeWidth={2}
              >
                {chartData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={CHART_COLORS[index % CHART_COLORS.length]} />
                ))}
              </Pie>
              <Tooltip content={<CustomTooltip />} />
              <Legend layout="horizontal" verticalAlign="bottom" align="center" wrapperStyle={{ paddingTop: 20 }} />
            </PieChart>
          </ResponsiveContainer>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              textAlign: "center",
              pointerEvents: "none",
            }}
          >
            <Typography variant="h5" sx={{ fontWeight: 700, color: darkGreyText }}>
              {totalOrdersToday}
            </Typography>
            <Typography variant="caption" sx={{ color: mediumGreyText }}>
              Total Orders
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  )
}

const MonthlyOrdersSummary = ({ data, loading }) => {
  const getThisMonthTotals = (raw) => {
    const now = new Date()
    const month = now.getMonth()
    const year = now.getFullYear()
    const totals = { pending: 0, processing: 0, shipped: 0, delivered: 0 }

    if (!raw) return totals
    if (!Array.isArray(raw)) {
      return {
        pending: Number(raw.pending || 0),
        processing: Number(raw.processing || 0),
        shipped: Number(raw.shipped ?? raw.shipping ?? 0),
        delivered: Number(raw.delivered || 0),
      }
    }

    raw.forEach((item) => {
      const d = item?.date ? new Date(item.date) : null
      const isInThisMonth = d ? d.getMonth() === month && d.getFullYear() === year : true
      if (!isInThisMonth) return

      totals.pending += Number(item.pending || 0)
      totals.processing += Number(item.processing || 0)
      totals.shipped += Number(item.shipped ?? item.shipping ?? 0)
      totals.delivered += Number(item.delivered || 0)
    })
    return totals
  }

  const monthTotals = getThisMonthTotals(data)
  const chartData = [
    { status: "Pending", value: monthTotals.pending, color: accentOrange },
    { status: "Processing", value: monthTotals.processing, color: accentBlue },
    { status: "Shipped", value: monthTotals.shipped, color: accentAmber },
    { status: "Delivered", value: monthTotals.delivered, color: accentGreen },
  ]

  const totalOrders = chartData.reduce((sum, d) => sum + d.value, 0)
  const currentDate = new Date()
  const monthName = currentDate.toLocaleString("default", { month: "long" })
  const year = currentDate.getFullYear()

  return (
    <Card
      sx={{
        borderRadius: 3,
        boxShadow: "0 8px 25px rgba(0,0,0,0.1)",
        height: "100%",
        minHeight: 350,
        bgcolor: cardWhite,
      }}
    >
      <CardContent sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Typography variant="h6" sx={{ fontWeight: 600, color: darkGreyText, mb: 2 }}>
          Monthly Orders Summary
        </Typography>

        <Box sx={{ textAlign: "left", mb: 3 }}>
          <Typography variant="h5" sx={{ fontWeight: 700, color: primaryGreen }}>
            {monthName} {year}
          </Typography>
        </Box>

        <Box sx={{ flexGrow: 1, minHeight: 260 }}>
          <ResponsiveContainer width="100%" height={260}>
            <BarChart data={chartData} margin={{ top: 20, right: 24, left: 0, bottom: 10 }} barSize={40}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke={lightGreyBlue} />
              <XAxis dataKey="status" stroke={mediumGreyText} tick={{ fill: mediumGreyText, fontSize: 12 }} />
              <YAxis stroke={mediumGreyText} tick={{ fill: mediumGreyText, fontSize: 12 }} allowDecimals={false} />
              <Tooltip
                content={({ active, payload }) =>
                  active && payload && payload.length ? (
                    <Box
                      sx={{
                        bgcolor: cardWhite,
                        p: 1.5,
                        border: "1px solid #e0e0e0",
                        borderRadius: 2,
                        boxShadow: "0px 2px 10px rgba(0,0,0,0.1)",
                      }}
                    >
                      <Typography variant="body2" sx={{ fontWeight: 600, color: darkGreyText }}>
                        {payload[0].payload.status}: {payload[0].value} Orders
                      </Typography>
                    </Box>
                  ) : null
                }
              />
              <Bar dataKey="value" radius={[10, 10, 0, 0]}>
                {chartData.map((entry, index) => (
                  <Cell key={`bar-${index}`} fill={entry.color} />
                ))}
                <LabelList dataKey="value" position="top" style={{ fill: darkGreyText, fontWeight: 600 }} />
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </Box>

        {totalOrders === 0 && (
          <Box sx={{ textAlign: "center", mt: 2 }}>
            <Typography variant="body2" sx={{ color: mediumGreyText }}>
              No data available for this month
            </Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  )
}


const DashboardPage = () => {
  const [dashboardData, setDashboardData] = useState(null)
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"))
  const token = localStorage.getItem("token")
  const [ordercount, setordercount] = useState(null)

  const fetchDashboardData = async () => {
    if (!token) {
      setLoading(false)
      console.warn("Access token not found in localStorage. Redirecting to login or showing error.")
      return
    }

    try {
      setLoading(true)
      const response = await getWithTokenAPI(token, "/admin/admin-dashboard")

      if (response.statusCode === 200 && response.data) {
        setDashboardData({
          totalSellers: response.data.totalSellers || 0,
          totalUsers: response.data.totalUsers || 0,
          totalCategories: response.data.totalCategories || 0,
          totalProducts: response.data.totalProducts || 0,
          orders: {
            pending: response.data.orders?.pending || 0,
            processing: response.data.orders?.processing || 0,
            shipping: response.data.orders?.shipping || 0,
            delivered: response.data.orders?.delivered || 0,
          },
          todayOrders: response.data.todayOrders,
          monthlyOrdersSummary: response.data.monthlyOrdersSummary, // Use the actual API data
        })
      } else {
        toast.error("Failed to fetch dashboard data.")
        console.error("Error fetching dashboard data:", response.message)
      }
    } catch (error) {
      toast.error("An error occurred while fetching dashboard data.")
      console.error("API Error:", error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchDashboardData()
  }, [token])

  useEffect(() => {
    const fetchOrderData = async () => {
      const token = localStorage.getItem("token")
      if (!token) return

      try {
        const res = await getWithTokenAPI(token, "/order/find-all")
        if (res.statusCode === 200) {
          const orders = res.data.orders || []

          const validOrders = orders.filter((order) => {
            if (!order.cart_id?.cart || order.cart_id.cart.length === 0) {
              return false
            }

            return order.cart_id.cart.some((item) => item.seller_id?.name && item.seller_id.name.trim() !== "")
          })

          const pendingCount = validOrders.filter((order) => order.order_status === "Pending").length
          const processingCount = validOrders.filter((order) => order.order_status === "Processing").length
          const shippedCount = validOrders.filter((order) => order.order_status === "Shipped").length
          const deliveredCount = validOrders.filter((order) => order.order_status === "Delivered").length

          setordercount({ pendingCount, processingCount, shippedCount, deliveredCount })
        } else {
          toast.error(res.message || "Failed to load orders.")
        }
      } catch (error) {
        console.error("Fetch orders error:", error)
        toast.error("Failed to load orders due to a network error.")
      }
    }

    fetchOrderData()
  }, [token])

  const handleCardClick = (route) => {
    if (route) {
      navigate(`/backoffice/${route}`)
    }
  }

  const topCards = [
    {
      title: "Total Sellers",
      value: dashboardData?.totalSellers,
      icon: <SellersIcon fontSize="large" />,
      route: "sellermanagement",
    },
    {
      title: "Total Users",
      value: dashboardData?.totalUsers,
      icon: <UsersIcon fontSize="large" />,
      route: "usermanagement",
    },
    {
      title: "Total Categories",
      value: dashboardData?.totalCategories,
      icon: <CategoryIcon fontSize="large" />,
      route: "category",
    },
    {
      title: "Total Products",
      value: dashboardData?.totalProducts,
      icon: <ProductsIcon fontSize="large" />,
      route: "productmanagement",
    },
  ]

  const orderCards = [
    {
      title: "Pending Orders",
      value: ordercount?.pendingCount,
      icon: <PendingOrdersIcon fontSize="large" />,
      route: "order",
    },
    {
      title: "Processing Orders",
      value: ordercount?.processingCount,
      icon: <ProcessingOrdersIcon fontSize="large" />,
      route: "order",
    },
    {
      title: "Shipping Orders",
      value: ordercount?.shippedCount,
      icon: <ShippingOrdersIcon fontSize="large" />,
      route: "order",
    },
    {
      title: "Delivered Orders",
      value: ordercount?.deliveredCount,
      icon: <DeliveredOrdersIcon fontSize="large" />,
      route: "order",
    },
  ]

  const CardComponent = ({ title, value, icon, route, loadingState }) => (
    <Card
      onClick={() => handleCardClick(route)}
      sx={{
        borderRadius: 3,
        transition: "transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out",
        "&:hover": {
          transform: "translateY(-10px)",
          boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
          cursor: "pointer",
        },
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: 140,
        width: 230,
        backgroundColor: cardWhite,
        color: darkGreyText,
        position: "relative",
        overflow: "hidden",
      }}
    >
      <CardContent sx={{ flexGrow: 1, p: 3 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 1.5,
          }}
        >
          <Typography variant="subtitle1" sx={{ fontWeight: 600, color: darkGreyText }}>
            {title}
          </Typography>
          <Avatar
            sx={{
              bgcolor: lightGreyBlue,
              color: primaryGreen,
              width: 50,
              height: 50,
            }}
          >
            {icon}
          </Avatar>
        </Box>
        {loadingState ? (
          <Skeleton variant="text" width="70%" height={isSmallScreen ? 45 : 55} sx={{ bgcolor: lightGreyBlue }} />
        ) : (
          <Typography variant={isSmallScreen ? "h5" : "h4"} sx={{ fontWeight: 600, color: darkGreyText, mb: 4 }}>
            {value !== undefined && value !== null ? value : "N/A"}
          </Typography>
        )}
      </CardContent>
      <Box
        sx={{
          height: 4,
          backgroundColor: primaryGreen,
          width: "100%",
          position: "absolute",
          bottom: 0,
          left: 0,
          borderBottomLeftRadius: 12,
          borderBottomRightRadius: 12,
        }}
      />
    </Card>
  )

  return (
    <Box
      sx={{
        p: isSmallScreen ? 2 : 4,
        minHeight: "100vh",
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      <ToastContainer position="top-center" autoClose={2000} />

      {/* Top Row Cards */}
      <Grid
        container
        spacing={isSmallScreen ? 2 : 2}
        sx={{ mb: isSmallScreen ? 4 : 6, justifyContent: "space-evenly" }}
      >
        {topCards.map((card, index) => (
          <Grid item xs={12} sm={6} md={4} lg={2} key={index}>
            <CardComponent
              title={card.title}
              value={card.value}
              icon={card.icon}
              route={card.route}
              loadingState={loading}
            />
          </Grid>
        ))}
      </Grid>

      {/* Orders Section */}
      <Typography variant="h5" sx={{ mb: isSmallScreen ? 3 : 4, fontWeight: 700, color: darkGreyText, pl: 2 }}>
        Order Statistics
      </Typography>

      <Grid
        container
        spacing={isSmallScreen ? 2 : 2}
        sx={{ mb: isSmallScreen ? 4 : 6, justifyContent: "space-evenly" }}
      >
        {orderCards.map((card, index) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            lg={3}
            key={index}
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <CardComponent
              title={card.title}
              value={card.value}
              icon={card.icon}
              route={card.route}
              loadingState={loading}
            />
          </Grid>
        ))}
      </Grid>

      {/* Detailed Order Insights Section (Charts) */}
      <Typography variant="h5" sx={{ mb: isSmallScreen ? 3 : 4, fontWeight: 700, color: darkGreyText, pl: 2 }}>
        Detailed Order Insights
      </Typography>

      <Grid container spacing={isSmallScreen ? 2 : 4} style={{ width: "100%" }}>
        {/* Today's Orders Donut Chart */}
        <Grid item xs={12} md={6} style={{ width: "100%" }}>
          <TodayOrdersDonutChart data={dashboardData?.todayOrders} loading={loading} />
        </Grid>

        {/* Monthly Orders Summary - now a vertical bar chart */}
        <Grid item xs={12} md={6} style={{ width: "100%" }}>
          <MonthlyOrdersSummary data={dashboardData?.monthlyOrdersSummary} loading={loading} />
        </Grid>
      </Grid>
    </Box>
  )
}

export default DashboardPage
